(() => {
  if (customElements.get('ae-email-popup')) return;
  class EmailPopup extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.email = this.querySelector('[name=email]');
      this.status = this.querySelector('[role=status]');
      this.submitButton = this.querySelector('[type=submit]');
      this.events = new AbortController();
      const opts = { signal: this.events.signal };
      this.demo = this.dataset.demo === 'true';
      this.force = this.dataset.themeRole !== 'main' && new URLSearchParams(location.search).get('ae_popup_preview') === '1';
      this.key = this.dataset.themeRole === 'main' ? 'ae_email_popup_live_v1' : 'ae_email_popup_draft_v1';
      this.started = Date.now();
      this.previousY = scrollY;
      this.maxY = scrollY;
      this.upward = 0;
      this.shown = false;
      this.pending = false;
      this.success = false;
      this.completedLists = new Set();
      this.lastEmail = '';
      let pages = Number(this.read(sessionStorage, this.key + '_pages') || 0);
      const lastPath = this.read(sessionStorage, this.key + '_path');
      if (lastPath !== location.pathname) pages += 1;
      this.write(sessionStorage, this.key + '_pages', String(pages));
      this.write(sessionStorage, this.key + '_path', location.pathname);
      this.pages = pages;
      this.querySelector('.ae-signup__close').addEventListener('click', () => this.close(), opts);
      this.querySelector('.ae-signup__decline').addEventListener('click', () => this.close(), opts);
      this.dialog.addEventListener('cancel', e => { e.preventDefault(); this.close(); }, opts);
      this.dialog.addEventListener('click', e => {
        const r = this.dialog.getBoundingClientRect();
        if (e.target === this.dialog && (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)) this.close();
      }, opts);
      this.form.addEventListener('submit', e => { e.preventDefault(); this.submit(); }, opts);
      if (/thank-you-page-x19|\/checkouts?\/|\/account(?:\/|$)/.test(location.pathname)) return;
      if (this.force || (window.Shopify && Shopify.designMode)) this.timer = setTimeout(() => this.open(true), 600);
      else this.timer = setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
      if (this.dataset.exit === 'true') {
        document.addEventListener('mouseout', e => {
          if (matchMedia('(hover: hover) and (pointer: fine)').matches && !e.relatedTarget && e.clientY <= 0 && Date.now() - this.started >= 10000) this.open();
        }, opts);
        window.addEventListener('scroll', () => {
          const y = Math.max(0, scrollY);
          this.maxY = Math.max(this.maxY, y);
          this.upward = y < this.previousY ? this.upward + this.previousY - y : 0;
          this.previousY = y;
          const mobile = matchMedia('(pointer: coarse)').matches || innerWidth <= 768;
          if (mobile && this.maxY >= 240 && this.upward >= 140 && Date.now() - this.started >= 10000) this.open();
        }, { ...opts, passive: true });
      }
    }
    read(storage, key) { try { return storage.getItem(key); } catch (_) { return null; } }
    write(storage, key, value) { try { storage.setItem(key, value); } catch (_) {} }
    open(force = false) {
      if (this.shown || this.dialog.open || typeof this.dialog.showModal !== 'function') return;
      if (!force && (this.pages < Number(this.dataset.pages) || Number(this.read(localStorage, this.key + '_until')) > Date.now())) return;
      const otherModal = [...document.querySelectorAll('dialog[open], [role=dialog][aria-modal=true]')].some(el => {
        const style = getComputedStyle(el);
        return !el.hidden && style.visibility !== 'hidden' && style.display !== 'none' && el.getClientRects().length > 0;
      });
      if (otherModal) return;
      this.previousFocus = document.activeElement;
      this.dialog.showModal();
      this.shown = true;
      this.querySelector('.ae-signup__close').focus();
    }
    close() {
      if (!this.dialog.open) return;
      this.dialog.close();
      this.write(localStorage, this.key + '_until', String(Math.max(Number(this.read(localStorage, this.key + '_until')) || 0, Date.now() + Number(this.dataset.days) * 86400000)));
      if (this.previousFocus && this.previousFocus.isConnected) this.previousFocus.focus();
    }
    payload(listId, email) {
      return { data: { type: 'subscription', attributes: {
        custom_source: 'Aeternum Shopify email popup',
        profile: { data: { type: 'profile', attributes: { email,
          properties: { signup_source: 'shopify_theme_popup', signup_offer: 'welcome_15', signup_surface: this.dataset.themeRole === 'main' ? 'live_theme' : 'draft_theme' },
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
        } } }
      }, relationships: { list: { data: { type: 'list', id: listId } } } } };
    }
    async send(listId, email) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.dataset.site), {
          method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
          body: JSON.stringify(this.payload(listId, email)), signal: controller.signal
        });
        if (!response.ok) throw new Error('Signup was not accepted');
        this.completedLists.add(listId);
      } finally { clearTimeout(timeout); }
    }
    async submit() {
      if (this.pending || this.success || !this.form.reportValidity()) return;
      if (this.form.elements.company_website.value) return;
      const email = this.email.value.trim();
      this.status.dataset.error = 'false';
      if (this.demo) {
        this.form.hidden = true;
        this.status.textContent = this.dataset.demoComplete;
        this.status.focus();
        this.success = true;
        return;
      }
      const approved = (this.dataset.testEmail || '').trim().toLowerCase();
      if (approved && email.toLowerCase() !== approved) {
        this.status.dataset.error = 'true';
        this.status.textContent = this.dataset.notApproved;
        return;
      }
      if (this.lastEmail !== email.toLowerCase()) this.completedLists.clear();
      this.lastEmail = email.toLowerCase();
      this.pending = true;
      this.submitButton.disabled = true;
      this.status.textContent = this.dataset.sending;
      try {
        for (const id of [this.dataset.list, this.dataset.secondaryList].filter(Boolean)) {
          if (!this.completedLists.has(id)) await this.send(id, email);
        }
        this.success = true;
        this.form.hidden = true;
        this.status.textContent = this.dataset.success;
        this.write(localStorage, this.key + '_until', String(Date.now() + 365 * 86400000));
        this.status.focus();
      } catch (_) {
        this.status.dataset.error = 'true';
        this.status.textContent = this.completedLists.size ? this.dataset.partialError : this.dataset.error;
      } finally { this.pending = false; this.submitButton.disabled = false; }
    }
    disconnectedCallback() { clearTimeout(this.timer); this.events?.abort(); }
  }
  customElements.define('ae-email-popup', EmailPopup);
})();
